import React from "react";
import parse from "html-react-parser";
import { useTemplateStore } from "@/zustand/templateStore";

const TestimonialsCard = ({ testimonial }) => {
  const { isMobile, cleanMobile, cleanDesktop } = useTemplateStore();
  const cleanCheck = (isMobile == false && cleanDesktop) || (isMobile == true && cleanMobile);
  const directCheck = window.cleanDirect && window?.affiliate?.includes("-direct");
  const enableCleanVersion = directCheck | cleanCheck;
  const isEnhancedContrast = window.enhancedContrast;
  // Independent of Clean Mode: an editor toggle that forces the same safe/muted
  // star icon regardless of the cleanCheck/directCheck outcome above.
  const forceSafeStars = window.post_template?.checkout_v4_testimonials?.checkout_v4_testimonials_use_safe_stars;
  const useSafeStars = enableCleanVersion || forceSafeStars;

  return (
    <div data-testid="testimonials-card" className={`testimonials__box ${isEnhancedContrast && "enhancedContrast"}`}>
      <div className="testimonials__upperRow">
        <div className="testimonials__upperRow__inside">
          <div className="testimonials__stars">
            <span>
              <img
                width="84"
                height="16"
                src={`${window.template_root}/templates/checkout-pages/V4/src/public/stars/${
                  useSafeStars ? "safe" : "full"
                }/star-${testimonial.checkout_v4_testimonial_stars}.svg`}
              ></img>
            </span>
          </div>
          <div
            data-testid="testimonials-card-name"
            className={`testimonials__name ${isEnhancedContrast && "enhancedContrast"}`}
          >
            {testimonial.checkout_v4_testimonial_author}
          </div>
        </div>
        <div className="testimonials__buyerLabel">
          {window.post_template.checkout_v4_testimonials.tr_checkout_v4_testimonials_verifiedLabel}
        </div>
      </div>
      <div>
        <div
          data-testid="testimonials-card-title"
          className={`testimonials__title ${isEnhancedContrast && "enhancedContrast"}`}
        >
          {testimonial.tr_checkout_v4_testimonial_title}
        </div>
        <div
          data-testid="testimonials-card-description"
          className={`testimonials__text ${isEnhancedContrast && "enhancedContrast"}`}
        >
          {parse(testimonial.tr_checkout_v4_testimonial_description)}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsCard;
